var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"custom-checkbox"},[_c('div',{staticClass:"checkbox",on:{"click":_vm.toggleCheck}},[(_vm.isChecked)?_c('img',{staticClass:"checkmark",attrs:{"src":require("@/images/checkmark.svg")}}):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }